import { AppAction } from '../../config/appConfig'
import { useContext } from 'react'
import AuthorizationContext from '../../context/AuthorizationContext'

export default function useLogOut(): (type?: AppAction.Reset) => void {
    const { reset } = useContext(AuthorizationContext)

    return (type?: AppAction.Reset | AppAction.LogOut) => {
        reset()

        if (type === AppAction.Reset) {
            window.location.reload()
        }
    }
}
